// Description: This component renders the footer with a return button
// Update: 29/08/2025
// Author: Simon Franklin

// React Components and DOM Elements
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Material UI Components
import { Box } from '@mui/material';

// Components and functions from the project
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import ThemeColors from '../ThemeColors/ThemeColors';

// Render Your Component
function Footer() {
    const location = useLocation();
    const navigate = useNavigate();
    const path = location.pathname;

    const returnPagePrevious = () => {
        return path.split("/").slice(0, -1).join("/") || "/";
    };

    return (
        <Box sx={{
            width: '100%',
            backgroundColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'left',
        }}>
            <Box
                component="div"
                onClick={() => navigate(returnPagePrevious())}
                sx={{
                    color: ThemeColors.purple600,
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontFamily: 'Satoshi-Medium',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#fff",
                    border: "1px solid gray",
                    borderRadius: "9999px",
                    padding: "10px 15px",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f9f9f9" }
                }}
            >
                <KeyboardBackspaceOutlinedIcon 
                    sx={{ 
                        color: ThemeColors.purple600, 
                        marginRight: '5px', 
                        marginTop: '2px' 
                    }} 
                />
                Voltar para a página anterior
            </Box>
        </Box>
    );
}

export default Footer;
